import React from 'react';

const Logo = (props) => {
  return <img alt="Logo" src="/static/logo.png" height={43} {...props} />;
};

export default Logo;
